import { Tabs } from '../tab/_tab';

/***
 * 複数のタブグループを管理するマネージャークラス
 */
export class TabsManager {
  private tabGroups: Tabs[] = [];
  private observer: MutationObserver;

  constructor() {
    this.init();

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            if (node.classList.contains('ist-js__tabs')) {
              this.initializeTabGroup(node);
            }

            const nestedTabs = node.querySelectorAll('.ist-js__tabs');
            nestedTabs.forEach((nestedTab) => {
              if (nestedTab instanceof HTMLElement) {
                this.initializeTabGroup(nestedTab);
              }
            });
          }
        });
      });
    });

    this.observer.observe(document.body, { childList: true, subtree: true });
  }

  private init(): void {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        this.initializeTabGroups();
      });
    } else {
      this.initializeTabGroups();
    }
  }

  private initializeTabGroups(): void {
    const containers = document.querySelectorAll('.ist-js__tabs');
    containers.forEach((container) => {
      if (container instanceof HTMLElement) {
        try {
          this.initializeTabGroup(container);
        } catch (error) {
          console.error('Failed to initialize tab group:', error);
        }
      }
    });
  }

  public initializeTabGroup(container: HTMLElement): Tabs {
    const tabs = new Tabs(container);
    this.tabGroups.push(tabs);
    return tabs;
  }

  public getTabGroups(): Tabs[] {
    return this.tabGroups;
  }

  public destroy(): void {
    this.tabGroups.forEach((tabGroup) => tabGroup.destroy());
    this.tabGroups = [];
    this.observer.disconnect();
  }
}
